export default __webpack_public_path__ + "static/clutch-telecommunication-4ff830602ae821e55b3194d57f9bd1f7.svg";